/**
 * @author Ryan Gladstone, Umer Hassan
 */

function GroupTaskTriggerController(
  $scope,
  $q,
  $log,
  $state,
  $transition$,
  $translate,
  $timeout,
  schemaService,
  taskTriggersService,
  taskTypesService,
  toastWrapperService,
  analyticsService,
  taskTrigger,
  siteService
) {
  const { groupId } = $transition$.params();

  $scope.getSections = () => {
    siteService.getFilteredSections($scope.selectedWebsite._id)
      .then((sections) => {
        $scope.sections = sections;
      }, () => {
        $log.error('Error getting sections from Site Service');
      });
  };

  $q.all([
    siteService.getWebsites(),
    taskTypesService.getTaskTypes(),
    schemaService.getContentTypes(),
    schemaService.getStatuses('workflow'),
    siteService.getDefaultWebsite()
  ])
    .then((data) => {
      const [sites, taskTypes, contentTypes, workflowStatuses, defaultWebsite] = data;
      const { primaryWebsites } = $scope.taskTrigger;

      $scope.sites = sites;
      $scope.taskTypes = taskTypes;
      $scope.contentTypes = contentTypes;
      $scope.workflowStatusesFrom = workflowStatuses;
      $scope.workflowStatusesTo = workflowStatuses;

      if (Array.isArray(primaryWebsites) && primaryWebsites.length > 0) {
        $scope.selectedWebsites = sites
          .filter(site => primaryWebsites.indexOf(site._id) > -1);
      } else {
        $scope.selectedWebsites = [];
        $scope.taskTrigger.primaryWebsites = [];
      }

      $scope.selectedWebsite = defaultWebsite;

      const { task } = $scope.taskTrigger;
      task.website = task.website || $scope.selectedWebsite._id;
      $scope.getSections();
    }, (response) => {
      $log.error('GroupTaskTriggerController $q.all() error', response.error || response);
      toastWrapperService.createToast($translate.instant('ERROR_GETTING_REQUIRED_RESOURCE'), 'danger');
    }
    );

  $scope.taskTrigger = taskTrigger;
  $scope.triggerComplete = !!$scope.taskTrigger.id;

  if ($scope.triggerComplete) {
    if ($scope.taskTrigger.primaryWebsites && $scope.taskTrigger.primaryWebsites.length > 0) {
      $scope.primaryWebsitesFilter = true;
    }

    if ($scope.taskTrigger.sections && $scope.taskTrigger.sections.length > 0) {
      $scope.sectionFilter = true;
    }

    if ($scope.taskTrigger.contentType) {
      $scope.contentTypeFilter = true;
    }
  }

  $scope.section = {
    inheritance: true,
    path: null
  };

  $scope.onChangeWebsites = (id) => {
    const currentIndex = $scope.selectedWebsites
      .findIndex(site => site._id === id);

    if (currentIndex > -1) {
      $scope.selectedWebsites.splice(currentIndex, 1);
    } else {
      const currentSite = $scope.sites.find(site => site._id === id);
      $scope.selectedWebsites.push(currentSite);
    }

    $scope.taskTrigger.primaryWebsites = $scope.selectedWebsites
      .map(site => site._id);
  };

  $scope.sectionSelect = ($item) => {
    $scope.section.path = $item.path;
  };

  $scope.addSection = () => {
    if (!$scope.taskTrigger.sections) {
      $scope.taskTrigger.sections = [];
    }

    const existingSection = $scope.taskTrigger.sections
      .some(sec => sec.path === $scope.section.path);

    if (!existingSection) {
      const { path, inheritance } = $scope.section;
      $scope.taskTrigger.sections.push({ path, inheritance });
    }

    $scope.section.inheritance = true;
    $scope.section.path = null;
    $scope.sectionName = null;
  };

  $scope.removeSection = (section) => {
    const index = $scope.taskTrigger.sections
      .findIndex(sec => sec.path === section.path);
    $scope.taskTrigger.sections.splice(index, 1);
  };

  $scope.next = () => {
    $scope.triggerComplete = true;
  };

  $scope.submit = () => {
    $scope.submitted = true;
    $scope.alerts = [];

    $scope.task_trigger_form.$setSubmitted();

    if ($scope.sectionFilter) {
      $scope.task_trigger_form.$setValidity('sections', $scope.taskTrigger.sections.length > 0);
    }

    if ($scope.primaryWebsitesFilter) {
      $scope.task_trigger_form.$setValidity('primaryWebsites', $scope.taskTrigger.primaryWebsites.length > 0);
    }

    $timeout(() => {
      if ($scope.task_trigger_form.$invalid || !$scope.taskTrigger.task.priority) return;

      const trigger = { ...$scope.taskTrigger };

      if (!$scope.primaryWebsitesFilter) {
        trigger.primaryWebsites = null;
      }

      if (!$scope.sectionFilter) {
        trigger.sections = null;
      }

      if (!$scope.contentTypeFilter) {
        trigger.contentType = null;
      }

      $scope.requestRunning = true;
      taskTriggersService.saveTrigger(trigger)
        .then(() => {
          $scope.requestRunning = false;
          const updateType = $scope.taskTrigger.id ? 'UPDATED' : 'CREATED';
          const toastMessage = `${$translate.instant('TRIGGER')} ${$translate.instant(updateType)}`;

          toastWrapperService.createToast(toastMessage, 'success');

          const taskTriggerChangeType = $scope.taskTrigger.id ? 'updated' : 'created';
          analyticsService.trackEvent('Task triggger management', `Task triggger ${taskTriggerChangeType}`);

          // navigate to group overview page
          $state.go('groups.group.task-triggers', { id: groupId }, { reload: true });
        }, ({ data }) => {
          $log.error('GroupTaskTriggerController taskTriggersService.saveTrigger() error', data.error || data);
          $scope.requestRunning = false;
          toastWrapperService.createToast($translate.instant('TASK_TRIGGER_UPDATE_FAILED'), 'danger');
        });
    });
  };

  $scope.delete = () => {
    taskTriggersService.deleteTrigger($scope.taskTrigger.id)
      .then(() => {
        toastWrapperService.createToast($translate.instant('TRIGGER_DELETED'), 'success');
        analyticsService.trackEvent('Task triggger management', 'Task triggger deleted');

        // navigate to group overview page
        $state.go('groups.group.task-triggers', { id: groupId }, { reload: true });
      }, (response) => {
        $log.error('GroupTaskTriggerController $scope.delete() error', response.error || response);
        toastWrapperService.createToast($translate.instant('TASK_TRIGGER_UPDATE_FAILED'), 'danger');
      });
  };
}

const arr = [
  '$scope',
  '$q',
  '$log',
  '$state',
  '$transition$',
  '$translate',
  '$timeout',
  'schemaService',
  'taskTriggersService',
  'taskTypesService',
  'toastWrapperService',
  'analyticsService',
  'taskTrigger',
  'siteService',
  GroupTaskTriggerController
];

module.exports = (ngModule) => {
  ngModule.controller('GroupTaskTriggerController', arr);
};
